import * as angular from "angular";
import { TourStep } from "../../../../app/tour/tour-step";
import { TourService } from "../../../../app/tour/tour.service";
import { Component } from "../../../component-decorator";
import { PrintLabelController } from "../../../components/print/print-label.controller";
import { ModalEditarEncomendaController } from "../modal/editar-encomenda/modal-editar-encomenda.controller";
import { ModalRemoverEncomendaController } from "../modal/remover-encomenda/modal-remover-encomenda.controller";
import { PopoverPosition } from "@mandae/ng-popover";
import * as _ from "lodash";
import downloadFile from "../../../../app/download-file";
// tslint:disable-next-line: import-spacing
import { ModalRemoverEncomendaSelecionadaController }
from
"../modal/remover-encomenda-selecionada/modal-remover-encomenda-selecionada.controller";

@Component({
  componentName: "appListaEncomenda",
  template: require("./lista-encomenda.html"),
  controllerAs: "vm",
})
export class ListaEncomendaComponent implements angular.IController {
  public offset = 0;
  public limit = 750;
  public user;
  public isColetaAtrasada = false;
  public alerts = [];
  public filterSelected = "todas";
  public loadingSearch = false;
  public packages = null;
  public total = 0;
  public freedom = true;
  public checkboxes = { checked: false, items: {} };
  public sort = "codigoRastreamento:asc";
  public pedido;
  public jaFoiImpressa = null;
  public errors = {};

  private print;
  private veiculo;

  public pedidosNuvemShop = [];
  public nuvemshopReady = false;
  public printingEtiquetas = false;

  constructor(
    private $scope,
    private $state,
    private $stateParams,
    private $uibModal,
    private $filter,
    private $controller,
    private $q: angular.IQService,
    private Pedido,
    private Auth,
    private Perfil,
    private Cep,
    private Endereco,
    private localStorageService,
    private Coleta,
    private Historico,
    private Encomenda,
    private PROVIDERS,
    private $mdToast,
    private $tour: TourService
  ) {
    "ngInject";

    this.user = localStorageService.get("user");
    this.print = new PrintLabelController(Pedido);
  }

  public async $onInit() {
    const values = await this.$q.all([
      this.Perfil.getClienteData(this.user.id),
      this.Coleta.isColetaAtrasada(),
      this.carregarListaEncomendas(),
    ]);

    this.user = values[0];
    this.isColetaAtrasada = values[1];

    this.user.ativo = this.user.situacaoCadastral === "ATIVO";
    this.user.freedomProgramada =
      this.user.planoContrato.tipo === "FREEDOM" &&
      this.user.formaColeta === "Agendada";
    this.freedom = this.Perfil.getCacheUserData().freedom;

    if (this.$stateParams.retornoDaEdicao) {
      this.addAlert("Encomenda alterada com sucesso.", "success");
    }

    if (this.$stateParams.collectionTour) {
      this.startCollectionTour();
    }

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const pedidos = urlParams.get("pedidos");

    if (pedidos) {
      this.nuvemshopReady = true;
      this.pedidosNuvemShop[0] = pedidos;
      if (pedidos.includes(",")) {
        this.pedidosNuvemShop = pedidos.split(",");
      }

      this.loadNuvemShop();
    }
  }

  public async loadNuvemShop() {
    for (let i = 0; i < this.pedido.remessas.length; i++) {
      if (
        this.pedidosNuvemShop.includes(
          this.pedido.remessas[i].codigoRastreamento
        )
      ) {
        this.checkboxes.items[this.pedido.remessas[i].id] = true;
      }
    }
    this.printingEtiquetas = true;
    await this.printLabels(this.checkboxes);
    this.printingEtiquetas = false;

    const toast = this.$mdToast
      .simple()
      .textContent("Etiqueta(as) gerada(as) - Agora basta solicitar a coleta")
      .action("OK")
      .hideDelay(0);
    toast._options.position = "bottom center";

    this.$mdToast.show(toast);

    sessionStorage.removeItem("webapp.plataforma");
  }

  public addAlert(msg, type) {
    this.alerts.push({ msg, type });
  }

  public closeAlert(index) {
    this.alerts.splice(index, 1);
  }

  public sortContains(coluna) {
    return this.sort.split(":")[0] === coluna;
  }

  public sortByColumn(coluna) {
    if (!coluna) {
      return;
    }

    const order = this.sort.split(":")[1] === "asc" ? "desc" : "asc";

    this.sort = coluna + ":" + order;
    this.offset = 0;
    this.search(coluna);
  }

  public goToPage(page) {
    this.offset = this.limit * (page - 1);
    this.search();
  }

  public async search(coluna?: string) {
    if (!this.pedido.id) {
      this.pedido = { remessas: [] };
      this.packages = [];
      return;
    }

    try {
      const data = await this.Historico.getListaEncomendas(
        {
          pedidoId: this.pedido.id,
          jaFoiImpressa: this.jaFoiImpressa,
          situacaoPedido: "Nova",
          sort: this.sort,
        },
        this.offset,
        this.limit
      );

      this.pedido.remessas = data.pedidos;
      this.packages = data.pedidos;
      this.total = this.pedido.remessas.length;
    } catch (e) {
      this.pedido = { remessas: [] };
      this.packages = [];
    }
  }

  public isEmpty() {
    if (!this.pedido || !this.pedido.remessas) {
      return true;
    }

    return !this.print.hasSelected(
      this.checkboxes,
      this.pedido.remessas.length
    );
  }

  public selectAll() {
    this.checkboxes = this.print.toggleSelectAll(
      this.checkboxes,
      this.pedido.remessas
    );
  }

  public async printLabels(orders) {
    if (!this.print.hasSelected(this.checkboxes) && angular.isObject(orders)) {
      this.addAlert(
        "Selecione as encomendas antes de imprimir suas etiquetas.",
        "danger"
      );
    } else {
      const sort = this.pedido.remessas.map((r) => r.id.toString());
      await this.print.getLabelsToPrint(orders, sort);
      await this.carregarListaEncomendas(true);
    }
  }

  public async printLabelsEmLote() {
    try {
      const data = await this.Pedido.printLabelEmLote(
        this.Auth.getCurrentUser().id
      );

      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(data.response);
      } else {
        const objectUrl = URL.createObjectURL(data.response);
        const link = document.createElement("a");
        link.href = objectUrl;
        link.target = "_blank";
        link.click();
      }

      return true;
    } catch (error) {
      alert("Não há etiquetas para serem geradas");
    }
  }

  public async deleteAll() {
    if (!this.print.hasSelected(this.checkboxes)) {
      this.addAlert(
        "Selecione ao menos uma encomenda para cancelar.",
        "danger"
      );
      return;
    }

    const payload = [];
    Object.entries(this.checkboxes.items).filter(item => item[1] === true).map(item => {
      const remessa = this.pedido.remessas.find(r => r.id.toString() === item[0]);
      if (remessa) {
        payload.push({
          idPedido: this.pedido.id,
          idEncomenda: item[0],
          codigoRastreamento: remessa.codigoRastreamento
        });
      }
    });
    const pedido = await this.$uibModal.open({
      animation: false,
      template: require("../modal/remover-encomenda-selecionada/modal-remover-encomenda-selecionada.html"),
      controller: ModalRemoverEncomendaSelecionadaController,
      resolve: {
        pedido: () => this.pedido,
      },
    }).result;
    try {
      const resultado = await this.Encomenda.removerTodasSelecionadas(payload);
      this.processarCancelamento(resultado);
      // Recarrega a lista do servidor
      await this.carregarListaEncomendas(true);
    } catch (e) {
      this.processarCancelamento(e);
    }
  }

  public resetSelectLabels() {
    this.checkboxes = this.print.toggleSelectAll(
      this.checkboxes,
      this.pedido.remessas,
      true
    );
  }

  public hasNoSelected() {
    this.checkboxes.checked = this.print.hasNoSelected(this.checkboxes);
  }

  public searchLabels() {
    switch (this.filterSelected) {
      case "etiquetasGeradas":
        this.jaFoiImpressa = true;
        break;
      case "etiquetasNaoGeradas":
        this.jaFoiImpressa = false;
        break;
      default:
        this.jaFoiImpressa = null;
        break;
    }
    this.search();
  }

  public editarEncomenda(encomenda) {
    this.$uibModal.open({
      animation: false,
      template: require("../modal/editar-encomenda/modal-editar-encomenda.html"),
      controller: ModalEditarEncomendaController,
      windowClass: "edicao-encomenda",
      resolve: {
        encomendaId: () => encomenda.id,
      },
    });
  }

  public async removerEncomenda(remessa) {
    const hasLabelPrinted = remessa.jaFoiImpressa;
    const encomenda = await this.$uibModal.open({
      animation: false,
      template: require("../modal/remover-encomenda/modal-remover-encomenda.html"),
      controller: ModalRemoverEncomendaController,
      resolve: {
        remessa: () => remessa,
        msgLabelPrinted: hasLabelPrinted,
      },
    }).result;

    try {
      const resultado = await this.Encomenda.remover(this.pedido, encomenda);
      this.processarCancelamento(resultado);
      // Recarrega a lista do servidor
      await this.carregarListaEncomendas(true);
    } catch (e) {
      this.processarCancelamento(e);
    }
  }

  public showProviderLabel(slug) {
    const provider = this.PROVIDERS.find((p) => p.slug === slug);
    return (provider && provider.name) || "";
  }

  servicosAdicionais(encomenda) {
    const servicos = [];
    if (encomenda) {
      if (encomenda.ar === true) {
        servicos.push("AR");
      }
      if (encomenda.maoPropria === true) {
        servicos.push("MP");
      }
      if (Number(encomenda.valorDeclarado) > 0) {
        const valorDecl = this.$filter("currency")(
          encomenda.valorDeclarado,
          "R$ "
        );
        servicos.push("VD " + valorDecl);
      }
    }

    return servicos.join(" ");
  }

  private async carregarListaEncomendas(force = true) {
    try {
      const pedido = await this.Pedido.getPedidoAsync(force);

      if (pedido) {
        this.veiculo = pedido.veiculo && pedido.veiculo.replace(/\s/g, "");
        this.pedido = pedido;

        return this.search();
      }
    } catch (err) {
      console.log(err);
    }
  }

  private tratarErrosBackEnd(err) {
    this.errors = {};
    if (err != null && err.erro) {
      this.addAlert(err.erro, "danger");
    } else if (err != null && err[0] != null) {
      this.addAlert(err[0].message || err[0].erro, "danger");
    } else if (err.data && err.data.erro) {
      this.addAlert(err.data.erro, "danger");
    } else if (err.data && err.data.length) {
      for (const erro in err.data) {
        if (err.data.hasOwnProperty(erro)) {
          this.$scope.$emit("erroEncontrado", err.data[erro].message);
        }
      }
    }
  }

  private startCollectionTour() {
    const next = {
      text: "Ir para Histórico",
      action: (ev, ref) => {
        ref.close("to_next_section");
        this.$state.go("lista-pedidos", { tour: true }, { inherit: false });
      },
    };

    const stepsConfig: TourStep[] = [
      {
        title: "Controle suas coletas",
        text:
          "Veja informações sobre sua próxima coleta, incluindo o veículo e quem será o motorista." +
          "Você ainda pode cancelar a coleta ou reagendá-la!",
        attachTarget: () =>
          document.querySelector<HTMLElement>(
            '.menu-container a[href*="/pedido"]'
          ),
      },
    ];

    if (this.total > 0) {
      stepsConfig.push(
        {
          title: "Editar dados",
          text: "Aqui você pode cancelar uma encomenda, imprimir etiqueta ou editar dados.",
          attachTarget: () =>
            document.querySelector<HTMLElement>(".table-freedom th:last-child"),
        },
        {
          title: "Gerar etiquetas",
          text:
            "Selecione as encomendas para as quais deseja gerar etiqueta de postagem.<br/>" +
            "Para visualizar as etiquetas, desabilite o bloqueador de pop-ups do seu navegador.<br/>" +
            "<b>Atenção: Deixe as encomendas prontas com no mínimo 30 min antes do horário agendado da coleta.</b>",
          attachTarget: () =>
            document.querySelector<HTMLElement>(
              'button[title="Imprimir etiquetas"]'
            ),
        }
      );
    }

    if (
      [
        "RetiradaAgendada",
        "ColaboradorSelecionado",
        "AguardandoColaborador",
      ].includes(this.pedido.codigoSituacao)
    ) {
      stepsConfig.push(
        {
          title: "Coleta com segurança",
          text:
            "Aqui você acompanha informações sobre o motorista e o veículo que irá efetuar " +
            "sua coleta assim que estiverem a caminho do seu endereço.<br/>" +
            "<b>Lembre-se: o veículo só poderá aguardar 15 minutos após o horário agendado," +
            " caso a coleta não ocorra o veículo será retirado.</b>",
          attachTarget: () =>
            document.querySelector<HTMLElement>(".colaborador-content"),
        },
        {
          title: "Reagendamento de coleta",
          text: "Você pode reagendar a coleta até 3 horas antes do horário marcado, não sendo possível reagendar para o mesmo dia.",
          attachTarget: () =>
            document.querySelector<HTMLElement>(
              '.btn-group[aria-label="Reagendar coleta"]'
            ),
        },
        {
          title: "Cancelamento de coleta",
          text: "Voce pode cancelar a coleta até 3 horas antes do horário marcado.",
          attachTarget: () =>
            document.querySelector<HTMLElement>(
              '.btn-group[aria-label="Cancelar coleta"]'
            ),
        }
      );
    }

    stepsConfig[stepsConfig.length - 1].next = next;

    const steps = this.$tour.makeTour(stepsConfig);

    this.$tour.start(steps).subscribe();
  }

  private processarCancelamento(resultado: any) {
    if (resultado.sucesso) {
      // Mostra mensagem de sucesso
      this.addAlert(resultado.mensagem, "success");

      // Mostra erros se houver (para casos de sucesso parcial)
      if (resultado.erros && resultado.erros.length > 0) {
        resultado.erros.forEach(erro => {
          this.addAlert(erro.message || erro.mensagem || erro, "warning");
        });
      }
    } else if (resultado.parcial) {
      // Caso PARCIAL: consolida mensagem principal + erros em uma única caixa laranja
      let mensagemCompleta = resultado.mensagem || "Processamento parcial";

      if (resultado.erros && resultado.erros.length > 0) {
        const detalhesErros = resultado.erros.map(erro => {
          let detalhe = "";
          if (erro.codigoRastreamento) {
            detalhe += `• ${erro.codigoRastreamento}: `;
          }
          detalhe += erro.mensagem || erro.message || erro;
          return detalhe;
        }).join("\n");

        mensagemCompleta += "\n\nDetalhes dos erros:\n" + detalhesErros;
      }

      this.addAlert(mensagemCompleta, "warning");
    } else if (resultado.falha) {
      // Caso FALHA: consolida mensagem principal + erros em uma única caixa vermelha
      let mensagemCompleta = resultado.mensagem || "Processamento falhou";

      if (resultado.erros && resultado.erros.length > 0) {
        const detalhesErros = resultado.erros.map(erro => {
          let detalhe = "";
          if (erro.codigoRastreamento) {
            detalhe += `• ${erro.codigoRastreamento}: `;
          }
          detalhe += erro.mensagem || erro.message || erro;
          return detalhe;
        }).join("\n");

        mensagemCompleta += "\n\nDetalhes dos erros:\n" + detalhesErros;
      }

      this.addAlert(mensagemCompleta, "danger");
    } else {
      // Extrai mensagem de erro de forma robusta
      let mensagemErro = "Erro ao cancelar encomenda(s)";

      if (resultado.mensagem) {
        mensagemErro = resultado.mensagem;
      } else if (resultado.data && resultado.data.mensagem) {
        mensagemErro = resultado.data.mensagem;
      } else if (resultado.data && resultado.data.message) {
        mensagemErro = resultado.data.message;
      } else if (typeof resultado === 'string') {
        mensagemErro = resultado;
      }

      // Para erros completos, também consolida em uma única mensagem se houver erros específicos
      if (resultado.erros && resultado.erros.length > 0) {
        const detalhesErros = resultado.erros.map(erro => {
          let mensagemEspecifica = erro.message || erro.mensagem || erro;
          if (typeof mensagemEspecifica === 'object') {
            mensagemEspecifica = JSON.stringify(mensagemEspecifica);
          }
          return `• ${mensagemEspecifica}`;
        }).join("\n");

        mensagemErro += "\n\nDetalhes:\n" + detalhesErros;
      }

      // Mostra mensagem de erro consolidada
      this.addAlert(mensagemErro, "danger");
    }
  }
}
